/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CancelByGroupResponse
 */
export interface CancelByGroupResponse {
  /**
   *
   * @type {string}
   * @memberof CancelByGroupResponse
   */
  groupKey: string;
  /**
   *
   * @type {number}
   * @memberof CancelByGroupResponse
   */
  cancelledCount: number;
}

/**
 * Check if a given object implements the CancelByGroupResponse interface.
 */
export function instanceOfCancelByGroupResponse(
  value: object,
): value is CancelByGroupResponse {
  if (!("groupKey" in value) || value["groupKey"] === undefined) return false;
  if (!("cancelledCount" in value) || value["cancelledCount"] === undefined)
    return false;
  return true;
}

export function CancelByGroupResponseFromJSON(
  json: any,
): CancelByGroupResponse {
  return CancelByGroupResponseFromJSONTyped(json, false);
}

export function CancelByGroupResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CancelByGroupResponse {
  if (json == null) {
    return json;
  }
  return {
    groupKey: json["groupKey"],
    cancelledCount: json["cancelledCount"],
  };
}

export function CancelByGroupResponseToJSON(json: any): CancelByGroupResponse {
  return CancelByGroupResponseToJSONTyped(json, false);
}

export function CancelByGroupResponseToJSONTyped(
  value?: CancelByGroupResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    groupKey: value["groupKey"],
    cancelledCount: value["cancelledCount"],
  };
}
